// @flow
import * as React from 'react';

import { selectRawProductsArray } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Base } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

const OwnershipDisclaimer = (): React.MixedElement | null => {
  const { __ } = useTranslator();

  const products = useAppSelector(selectRawProductsArray);

  const hasTransfer = products.find(
    ({ process, productType }) =>
      productType === 'domain' && process === 'transfer',
  );
  const hasCloud = products.find(({ productType }) => productType === 'cloud');

  const hasRenew = products.find(({ process }) => process === 'renew');

  const hasChangeOwner = products.find(
    ({ payload }) => payload?.change_owner === true,
  );

  return hasTransfer || hasRenew || hasCloud ? (
    <Base padding="small" marginBottom="base" backgroundColor="surface">
      {[
        hasTransfer && !hasChangeOwner
          ? __(
              'The owner of the transferred domains cannot be modified as per registry policy. The owner will remain the same after the transfer.',
            )
          : '',
        hasTransfer && hasChangeOwner
          ? __(
              'The owner of the transferred domains can be specified afterwards.',
            )
          : '',
        hasRenew ? __('Owners will not change for renewed products.') : '',
        hasCloud
          ? __(
              "Cloud resources will be credited to the selected owner's Cloud account.",
            )
          : '',
      ]
        .filter(Boolean)
        .map((wording, idx, array) => (
          <span key={wording}>
            {wording}
            {idx < array.length - 1 && <br />}
          </span>
        ))}
    </Base>
  ) : null;
};

export default OwnershipDisclaimer;
